document.addEventListener('DOMContentLoaded', function() {
  const menu__toggler = document.getElementById('menu__toggle')
  const menu__wraper = document.querySelector('.header__menu')
  const menuLink = document.querySelectorAll('.header__menu__link')
  const menuSideWrap = document.querySelectorAll(`.menu__scrollar .menu__box`);
  if(menu__toggler){
    menu__toggler.addEventListener('click', ()=>{
      menu__wraper.classList.toggle('open')
      menu__toggler.classList.toggle('open')
    })
    menuLink.forEach((item) => {
      item.addEventListener('mouseover', ()=>{
          menuLink.forEach((x)=>{
            x.classList.remove('active')
            item.classList.add('active')
          })
          menuSideWrap.forEach((elm)=>{
              elm.classList.remove('showDrop');
              if(elm.dataset.id == item.id){                  
                elm.classList.add('showDrop');
              }
          })
      })      
    });
  }
  window.addEventListener('scroll', function() {
      var scroll = window.scrollY || window.pageYOffset;
      if (scroll >= 10) {
          document.body.classList.add('header-fixed');
      } else {
          document.body.classList.remove('header-fixed');
      }
  });
});